<header #header id="header" tabindex="-1" class="site-header">
	<div class="skip-link">
		<a (click)="skipLink()" href onclick="return false;" class="btn btn-secondary btn-skip"><span>Skip to main content</span></a>
	</div>

	<nav id="site-nav" class="navbar navbar-dark navbar-custom-theme justify-content-start align-items-stretch" aria-label="Site Navigation">
		<div id="logo-wrapper" class="nav-section">
			<button #sidebarCollapse type="button" id="sidebarCollapse" class="navbar-toggler" aria-label="Toggle primary navigation">
				<span class="navbar-toggler-icon"></span>
			</button>

			<a class="navbar-brand" routerLink="/">
				<img class="logo logo-white" src="assets/hillsdale-college-logo-white.svg" alt="Hillsdale College">
			</a>
		</div>

		<div id="header-nav-wrapper" class="nav-section ml-auto" aria-expanded="false" role="navigation">
			<div #primaryNav id="primary-nav">
				<ul class="nav-root">
					<ng-container *ngIf="symposiumsForNav$ | async as symposiums">
						<li class="nav-item dropdown">
							<a class="nav-link nav-level-1 dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:void(0);">
								All Symposiums
							</a>
							<ul class="dropdown-menu">
								<li *ngFor="let symposium of symposiums" class="nav-item">
									<a class="nav-link dropdown-item nav-level-2" [routerLink]="'/s/' + symposium.url_slug" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [innerHTML]="symposium.title|simpleMd"></a>
								</li>
							</ul>
						</li>
					</ng-container>
					<li class="nav-item nav-item-highlighted" *ngIf="donationUrl$ |async as donationUrl">
						<a class="nav-link nav-level-1" [href]="donationUrl" target="_blank">Donate</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</header>

<main #main id="main-content" tabindex="-1">
	<router-outlet></router-outlet>
</main>

<footer class="site-footer">
	<div class="container">
		<hr>

		<div class="row">
			<div class="col-12 text-center">
				<a href="https://www.hillsdale.edu/" target="_blank">
					<img class="logo logo-blue" src="assets/hillsdale-college-logo-blue.svg" alt="Hillsdale College">
				</a>
				<p>33 E. College St. Hillsdale, MI 49242</p>
			</div>
		</div>

		<div class="row my-3">
			<div class="col-12 text-center">
				<p>Hillsdale College &copy; 2020</p>
			</div>
		</div>
	</div>
</footer>
<!--ngx-spinner></ngx-spinner-->
<ngx-ui-loader fgsColor="#a91d39" pbColor="#a91d39" overlayColor="#ffffff88"></ngx-ui-loader>

<!--TODO replace with Angular call-->
<div class="modal fade" id="readingModal" tabindex="-1" role="dialog" aria-labelledby="readingModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="readingModalLabel">New message</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="iframe-container" style="padding-bottom: 90%; padding-top: 30px; height: 0; overflow: hidden;">
					<iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="screen-overlay"></div>
